import Vue from 'vue'
import {
  Image,
  Link,
  Input,
  Button,
  Tabs,
  TabPane,
  Empty,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Divider,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Select,
  Option,
  Popover,
  RadioGroup,
  Radio,
  Dialog,
  Loading
} from 'element-ui'

Vue.use(Image)
Vue.use(Link)
Vue.use(Input)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Empty)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Popover)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Loading)

Vue.prototype.$ELEMENT = { fontFamily: '微软雅黑', size: 'small' }
